var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-mt-10 md:tw-mt-6"},[_c('div',{staticClass:"tw-ml-5 tw-pt-4"},[_c('h2',{staticClass:"tw-text-xl md:tw-text-2xl c-blue-text title-font"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }